module.exports = __webpack_public_path__ + "img/perfil.44d1093d.png";